import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { stringify } from 'querystring';
import { makeEntityScaffold } from '@classpass/saga-tools';
import fetch from '../../../universal-fetch';
export var locationsByMsa = makeEntityScaffold('SAGA.API.LOCATIONS_BY_MSA', function (client, msaId) {
  return client.locations.getListV2(msaId).then(function (data) {
    return data.locations;
  });
});
export var locationSearch = makeEntityScaffold('SAGA.GAPI.PLACES_AUTOCOMPLETE', function (query, options) {
  return fetch("/_location/search?".concat(stringify(_objectSpread({
    input: query
  }, options))), {
    credentials: 'same-origin'
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data.predictions;
  });
});
export var geocode = makeEntityScaffold('SAGA.GAPI.GEOCODE', function (params) {
  return fetch("/_location/geocode?".concat(stringify(params)), {
    credentials: 'same-origin'
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data.results && data.results[0];
  });
});